import axios from 'axios';
import { handleResponse } from '../helpers/handleResponse';
import { authHeader } from './authHeader';


export const blogService = {
    sync
};

function sync(){
    return axios({
        method: 'get',
        url: '/api/blog/61112025220/sync',
        headers: authHeader()
    }).then(handleResponse);
}